<template>
  <div id="DSExportPDFForm" style="width: 100%;height: 100%">
    <el-dialog title="导出PDF" center :visible.sync="展示模态框" width="500px" @close="关闭模态框()">
      <el-form :model="表单" ref="表单" label-width='125px' class="justifyForm">
        <el-form-item label="客户" prop="客户">
          <el-select v-model="表单.客户" filterable placeholder="请选择" clearable @change="选择客户()">
            <el-option v-for="客户 in 客户列表" :key="客户.ID" :label="客户.AB_NAME" :value="客户.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店" prop="门店">
          <el-tooltip content="请先选择客户" :disabled="Boolean(表单.客户)">
            <el-select v-model="表单.门店" filterable placeholder="请选择" clearable :disabled="!表单.客户">
              <el-option v-for="门店 in 门店列表" :key="门店.PROJECT_ID" :label="门店.PROJECT_NAME" :value="门店.PROJECT_ID">
              </el-option>
            </el-select>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="送货日期范围" prop="送货日期范围">
          <el-date-picker v-model="表单.送货日期范围" type="daterange" value-format="yyyy-MM-dd" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="日期选项"
            :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否带客户抬头" v-if="是销售价">
          <el-radio-group v-model="表单.WHETHER_SHOW_CUSTOMER_NAME">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否合并" v-if="是销售价">
          <el-radio-group v-model="表单.是否合并">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印价格" v-if="priceType == 1">
          <el-radio-group v-model="表单.是否打印价格">
            <el-radio :label="0">不带价格</el-radio>
            <el-radio :label="1">带团餐公司价格</el-radio>
            <el-radio :label="2">带项目点价格</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印价格" v-else>
          <el-radio-group v-model="表单.是否打印价格">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印送货数量">
          <el-radio-group v-model="表单.是否打印送货数量">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印实收列">
          <el-radio-group v-model="表单.是否打印实收列">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否填充实收数量" v-if="表单.是否打印实收列">
          <el-radio-group v-model="表单.是否填充实收数量">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单据格式" v-if="priceType == 1">
          <el-radio-group v-model="表单.HALF_PAGE_FLAG">
            <el-radio :label="0">半联单</el-radio>
            <el-radio :label="1">全联单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="关闭模态框()">取 消</el-button>
        <el-button @click="exportPdf">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getHaveSupplyRelationshipProjectList } from '@/assets/api/sellOrder';
import http from '@/assets/common/http';
import util from '@/assets/common/util';


export default {
  props: {
    propVisible: {
      type: Boolean,
      default: false,
    },
    // 1: 销售价, 2: 采购价
    priceType: {
      type: Number,
      default: 1,
    },
    orderIdList: {
      type: Array,
      default: () => [],
    },
    // 1: 待送, 2: 待确认, 3: 历史
    orderStatus: {
      type: Number,
      default: 1,
    },
    propCustomerList: {
      type: Array,
      default: () => [],
    },
    isYfd: {
      type: Number,
      default: 0,
    },

  },
  computed: {
    是销售价 () {
      return this.priceType == 1;
    },
  },
  data () {
    return {
      客户列表: this.propCustomerList,
      门店列表: [],
      展示模态框: this.propVisible,
      表单: {
        客户: null,
        门店: null,
        送货日期范围: [],
        是否合并: 0,
        是否打印价格: 0,
        是否打印送货数量: 0,
        是否打印实收列: 0,
        是否填充实收数量: 0,
        HALF_PAGE_FLAG: 0,
        WHETHER_SHOW_CUSTOMER_NAME: 0,
      },
      日期选项: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  created () { },
  methods: {
    exportPdf () {
      if (!this.orderIdList.length && !(this.表单.客户 && this.表单.送货日期范围.length)) {
        this.$message.show({ text: '请勾选订单或选择客户和送货日期范围', type: 'warning' });
        return;
      }
      const 参数 = {
        SERVICE_ID: '10179',
        OTYPE: 16,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        STATUS: this.orderStatus,
        WHETHER_PRINT_NEED_COUNT: this.表单.是否打印送货数量,
        WHETHER_PRINT_REAL_COLUMN: this.表单.是否打印实收列,
        WHETHER_FILL_REAL_COUNT: this.表单.是否填充实收数量,
        PRICE_TYPE: this.priceType,
        YFD: this.isYfd,
      };
      if (this.priceType == 1) {
        参数.WHETHER_MERGE_PRODUCT = this.表单.是否合并;
        参数.HALF_PAGE_FLAG = this.表单.HALF_PAGE_FLAG;
        参数.WHETHER_SHOW_CUSTOMER_NAME = this.表单.WHETHER_SHOW_CUSTOMER_NAME;
      }
      if (this.orderIdList.length) {
        参数.ORDER_ID_LIST = this.orderIdList;
      }
      if (this.表单.客户) {
        参数.TC_ID = this.表单.客户;
      }
      if (this.表单.门店) {
        参数.PROJECT_ID = this.表单.门店;
      }
      if (this.表单.送货日期范围.length) {
        参数.DATE_RANGE = this.表单.送货日期范围;
      }
      if (this.表单.是否打印价格 == 2) {
        参数.PRICE_TYPE = 3;
        参数.WHETHER_PRINT_PRICE = 1;
      } else {
        参数.WHETHER_PRINT_PRICE = this.表单.是否打印价格;
      }
      if (this.priceType == 2) {
        参数.YFD = 1;
      }
      http.post(参数).then((res) => {
        if (res && res[0]) {
          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
          this.关闭模态框();
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    关闭模态框 () {
      this.$emit('close');
    },
    选择客户 () {
      this.表单.门店 = null;
      this.$nextTick(() => {
        if (this.表单.客户) {
          const paramsProject = {
            TC_ID: this.表单.客户,
          };
          getHaveSupplyRelationshipProjectList(paramsProject).then((result) => {
            if (result[0]) {
              this.门店列表 = result;
            } else {
              this.门店列表 = [];
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } else {
          this.门店列表 = [];
        }
      });
    },
  },
};
</script>
<style scoped>
.el-button--text {
  margin: 0 0 0 10px;
}

.justifyForm>>>.el-form-item__label {
  text-align-last: justify;
}

.justifyForm>>>.el-input,
.el-select,
.el-date-editor,
.el-range-editor,
.el-input__wrapper {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrderExportPDFForm.vue